import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bike, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errorMessage } from "@/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/atm-seguros", { replace: true });
    } catch (err) {
      setError(errorMessage(err, "No pudimos iniciar sesion"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4" data-testid="admin-login">
      <form onSubmit={submit} className="bg-white rounded-2xl p-8 w-full max-w-sm shadow-2xl">
        <div className="mb-8">
          <img src="/assets/logo-spm.png" alt="Seguros Para Moto" className="h-11 w-auto" data-testid="login-logo" />
          <p className="text-xs text-slate-500 mt-2">Panel de gestion - Productor Asesor de Seguros Mat. SSN 89459</p>
        </div>
        <label className="text-sm font-semibold text-slate-700 mb-1.5 block" htmlFor="login-email">Email</label>
        <input id="login-email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full h-11 px-3 mb-4 bg-white border border-slate-300 rounded-lg focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 outline-none" />
        <label className="text-sm font-semibold text-slate-700 mb-1.5 block" htmlFor="login-password">Contrasena</label>
        <input id="login-password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full h-11 px-3 mb-4 bg-white border border-slate-300 rounded-lg focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 outline-none" />
        {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-2.5 mb-4" data-testid="login-error">{error}</p>}
        <button data-testid="login-submit-button" disabled={loading}
          className="w-full h-11 rounded-[14px] bg-[#1C1C1E] hover:bg-zinc-800 disabled:bg-slate-300 text-white font-semibold flex items-center justify-center gap-2 transition">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Ingresar
        </button>
      </form>
    </div>
  );
}
